<template>
    <div class="container" v-if="interactionModel">
        <h3>Individuelle Interaction bearbeiten</h3>
        <div class="button-row">
            <inputFloatLabel style="width: 48%" label="Interaction-Name" @input="nameChanged"
                             :value="interactionName"></inputFloatLabel>
            <TemplateInput style="width: 48%" label="Technischer Name" @input="technicalNameChanged"
                           :extension-text="selectedStandardInteraction ? selectedStandardInteraction.technical_name : ''"
                           :value="technicalName"></TemplateInput>
        </div>
        <div class="button-row">
            <Checkbox id="onDesktop" class="checkbox" v-model="interactionModel.on_desktop" title="Desktop"></Checkbox>
            <Checkbox id="onMobile" class="checkbox" v-model="interactionModel.on_mobile" title="Mobile"></Checkbox>
            <Checkbox id="onTablet" class="checkbox" v-model="interactionModel.on_tablet" title="Tablet"></Checkbox>
        </div>
        <div class="select-container">
            <div>
                Interaction-Typ wählen:
            </div>
            <div class="checkbox-container">
                <Checkbox :rounded="true" class="checkbox" v-for="int in standardInteractions" v-bind:key="int.id"
                          :id="'' + int.id"
                          @change="interactionSelectionChanged(int.id)" v-model="int.selected"
                          :title="int.technical_name"></Checkbox>
            </div>
        </div>
        <inputFloatLabel style="width: 100%; margin-top: 10px; margin-bottom: 10px" label="Beschreibung"
                         @input="descChanged"
                         :value="description"></inputFloatLabel>
        <AdaButton :loading="savingTemplate" title="INTERACTION SPEICHERN" type="createButton"
                   @click="saveClicked" style="width:fit-content"></AdaButton>
    </div>
</template>

<script>
    import InputFloatLabel from "../../../components/inputs/InputFloatLabel";
    import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
    import Checkbox from "../../../components/inputs/Checkbox";
    import TemplateInput from "../../../components/inputs/TemplateInput";
    import AdaButton from "../../../components/buttons/AdaButton";

    const InteractionsRepository = RepositoryFactory.get('interactions');

    export default {
        components: {
            InputFloatLabel,
            TemplateInput,
            Checkbox,
            AdaButton
        },
        props: {
            interactionId: {
                required: true,
                type: Number
            }
        },
        data: function () {
            return {
                mounted: false,
                interactionName: '',
                technicalName: '',
                standardInteractions: [],
                selectedStandardInteraction: null,
                interactionModel: null,
                description: '',
                savingTemplate: false
            }
        },
        name: "EditInteractionTemplateDialog",
        async mounted() {
            await this.fetchInteraction();
            await this.fetchStandardInteractions();
        },
        methods: {
            descChanged(val) {
                this.description = val;
            },
            nameChanged(val) {
                this.interactionName = val;
            },
            technicalNameChanged(val) {
                this.technicalName = val;
            },
            async fetchStandardInteractions() {
                try {
                    const {data} = await InteractionsRepository.getStandardInteractions();
                    data.forEach(int => {
                        int.selected = false;
                        if (this.interactionId === int.id) {
                            this.selectedStandardInteraction = int;
                            int.selected = true;
                        }
                    });
                    this.standardInteractions = data;
                } catch (e) {
                    console.error(e);
                    this.$noty.error("Fehler bei der Abfrage der standard Interactions");
                }
            },
            async fetchInteraction() {
                try {
                    const {data} = await InteractionsRepository.getInteraction(this.interactionId);
                    this.interactionModel = data;
                    this.technicalName = data.technical_name;
                    this.interactionName = data.name;
                    this.description = data.description;
                } catch (e) {
                    console.error(e);
                    this.$noty.error("Fehler bei der Abfrage der Interaction");
                }
            },
            interactionSelectionChanged(id) {
                this.selectedStandardInteraction = null;
                this.technicalName = '';
                this.standardInteractions.forEach(int => {
                    if (int.id !== id) {
                        int.selected = false;
                    } else if (int.selected) {
                        this.selectedStandardInteraction = int;
                        this.technicalName = int.name;
                    }
                })
            },
            async saveClicked() {
                this.savingTemplate = true;
                try {
                    await InteractionsRepository.updateInteraction(this.interactionModel.id, {
                        name: this.interactionName,
                        technical_name: this.technicalName,
                        description: this.description,
                        on_desktop: this.interactionModel.on_desktop,
                        on_mobile: this.interactionModel.on_mobile,
                        on_tablet: this.interactionModel.on_tablet,
                    });
                    this.$noty.success("Interaction erfolgreich aktualisiert!");
                    this.$emit('saved');
                } catch (e) {
                    console.error(e);
                    this.$noty.error("Fehler bei der Erstellung.");
                }
                this.savingTemplate = false;
            },
            toggleDevice: function () {
                switch (this.interactionModel.medium.toLowerCase()) {
                    case 'online':
                        this.interactionModel.medium = 'alle';
                        break;
                    case 'alle':
                        this.interactionModel.medium = 'online';
                        break;
                }
            },
            deviceInput: function () {
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        width: 600px;
        background-color: white;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }

    .button-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    .checkbox-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;
        max-height: 300px;
        overflow-y: auto;
    }

    .checkbox {
        width: 30%;
        justify-content: start;
        margin: 9px;
        padding: 2px 0;
        overflow: auto;
    }

    ::v-deep .pretty .state label:before,
    ::v-deep .pretty .state label:after {
        top: calc((0% - (100% - 20px)) - 8%) !important;
    }
</style>